module.exports = __webpack_public_path__ + "img/brandenburg.cc274322.jpg";